// Lodash
import _noop from 'lodash/noop';

// Constants
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
export var disableKeyUpDownInInputNumber = function disableKeyUpDownInInputNumber() {
  var inputNumberRef = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  inputNumberRef.onKeyDown = _noop; // eslint-disable-line no-param-reassign
  inputNumberRef.onKeyUp = _noop; // eslint-disable-line no-param-reassign
};